import Session from './Session.js'

export default class Usuario {
    //sempre que forem adicionados novos atributos, lembrar de declarar o clean do value no logout
    constructor(session=new Session(), permissoes='', menu_filtrado='', hash='') {

        this.session = session;
        this.permissoes = permissoes;
        this.menu_filtrado = menu_filtrado;
        this.hash = hash
    }
}


// WEBPACK FOOTER //
// ./src/domain/login/Usuario.js